import SideModal from "/src/components/modal/SideModal/SideModal";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import './AnalyticsCriteriaProfil.css';
import "tippy.js/dist/tippy.css";
import AnalyticsCriteriaHeader from "../AnalyticsCriteriaHeader/AnalyticsCriteriaHeader";
import BarChart from "../../BarChart/BarChart";
import AgentCriteriaAnalyticsGrid from "../AgentCriteriaAnalyticsGrid/AgentCriteriaAnalyticsGrid";
import { buildCriteriaKey } from "/src/utils/criteriaKey";
const AnalyticsCriteriaProfil = NiceModal.create(({ item, onRefresh, criteriaResults = [] }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    const byAgent = item?.byAgent || [];

    const handleClose = () => {
        onClose();
        onRefresh && onRefresh()
    }
    return (
        <SideModal id={modal.id} autoClose={true} onClose={handleClose} style={{ width: '55%', zIndex: '1000' }} autoCloseChangePageOnly={false} name="analytics_criteria_modal">
            <div>
                <div className="button-leave" id="close_modal_container close_convo_modal_container" onClick={handleClose}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>

                </div>
                <br></br>
                <div className="title-modal-analytics">Criteria card </div>
            </div>
            <AnalyticsCriteriaHeader item={item} byAgent={byAgent} criteriaResults={criteriaResults}></AnalyticsCriteriaHeader>
            <div className="divider div-transparent div-dot"></div>

            <div style={{ fontSize: "14px" }}> Agent breakdown </div>
            <br></br>
            <div style={{ height: 250 }}>
                <BarChart showYAxis={true} title={"Pass Rate"} yAxisLabel="Agents" height={250} data={item?.agentBreakdown} />
            </div>
            <br></br>
            <br></br>
            <br></br>
            <div className="divider div-transparent div-dot"></div>
            <br></br>
            <div style={{ fontSize: "14px" }}> Criteria score by agent </div>
            <br></br>
            <AgentCriteriaAnalyticsGrid data={byAgent} criteriaId={item?.id != null ? buildCriteriaKey(item.category, item.id) : null} criteriaResults={criteriaResults}></AgentCriteriaAnalyticsGrid>
        </SideModal>
    );
});

export default AnalyticsCriteriaProfil;